module.exports = __webpack_public_path__ + "static/img/IconAI-gray.77db9157.svg";